export const sourceConfiguration =
{
    status: true,
    message: "Source Configured Successfully"
}


